import { useCallback } from 'react'
import { removeSessionFromLocalStorage } from '@core/http-client'
import { queryClient } from '@core/query'
import { SessionQueryKey } from '../helpers/queryKeys'
import { GUEST_USER } from '../constants/guestUser'
import { closeSsrSession } from '../services/ssrSession'

export const useSessionLogout = () => {
    // Stable: registered as the http-client 401 handler, and kept in an effect dependency.
    return useCallback(() => {
        removeSessionFromLocalStorage()
        closeSsrSession()
        // Seed guest rather than evict — the observers are still mounted and would refetch `/me`
        // without a token.
        queryClient.setQueryData(SessionQueryKey.me(), GUEST_USER)
        queryClient.removeQueries({
            predicate: query => query.queryKey[0] !== SessionQueryKey.me()[0],
        })
    }, [])
}
